{
  "title": "Protection from Ballistics (UA)",
  "source": "Unearthed Arcana 7 - Modern Magic",
  "levelAndSchool": "3rd-level abjuration (technomagic)",
  "level": 3,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S, M (a shell casing)",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "This spell enchants the flesh of the target against the impact of bullets. Until the spell ends, the target has resistance to nonmagical ballistic damage."
  ],
  "spellLists": ["eldritch-knight", "sorcerer", "warlock", "wizard"]
}
